import { FC } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Divider from '@/components/UI/divider/Divider';
import Icon from '@/components/UI/icon/Icon';
import heap from '@/helpers/heap';
import { moneyFormat } from '@/helpers/props';
import styles from './SimilarProductsCard.module.scss';
interface SimilarProductsCardProps {
  data: any;
  index: number;
}
const SimilarProductsCard: FC<SimilarProductsCardProps> = ({
  data,
  index
}) => {
  const handleHeapEvent = () => {
    heap.track('product_card_click', {
      city_name: data?.location?.city,
      house_id: data?.id,
      position: index,
      instant: data?.badges?.includes('is_instant'),
      price_guarantee: data?.price_guarantee,
      from: 'similar',
      ismidterm: false
    });
  };
  return <Box component="article" className={styles['similar-products-card']} onClick={handleHeapEvent} data-sentry-element="Box" data-sentry-component="SimilarProductsCard" data-sentry-source-file="SimilarProductsCard.tsx">
      <Link href={`/houses/show/${data.id}`} passHref className={styles['similar-products-card-link']} data-sentry-element="Link" data-sentry-source-file="SimilarProductsCard.tsx">
        <Box component={'header'} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
          {data?.cover_photo?.absolute_url && <Box className={styles['similarHouse']} component={'figure'}>
              <Image src={data?.cover_photo?.absolute_url || ''} width={230} height={130} objectFit="cover" alt="check" />
            </Box>}
          <Box className={styles['header']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
            <Box className={styles['rating-section']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
              <Icon name="star-filled" type="primary" size={'small'} data-sentry-element="Icon" data-sentry-source-file="SimilarProductsCard.tsx" />
              <Box className={styles['rating-content']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
                {data?.reviews > 0 && data?.rank > 0 ? <>
                    <Typography variant="bodyM">
                      {data?.rank?.toFixed(1)?.includes('0') ? Math.round(data?.rank) : data?.rank?.toFixed(1)}
                    </Typography>
                    <Typography variant="bodyS" color="neutral_600">{`(${data?.reviews} نظر)`}</Typography>
                  </> : <Typography color="neutral_600" variant="bodyS">
                    اقامتگاه‌ جدید
                  </Typography>}
              </Box>
            </Box>

            <Box className={styles['card-title']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
              <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">{data.title}</Typography>
            </Box>

            <Box className={styles['info-section']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
              <Box className={styles['description-container']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
                <Typography variant={'bodyM'} color="neutral_600" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">{`${data?.rooms > 0 ? ` ${data?.rooms} اتاق ، ` : ''} تا ${data?.max_accommodates} مهمان `}</Typography>
              </Box>
              <Divider orientation="vertical" data-sentry-element="Divider" data-sentry-source-file="SimilarProductsCard.tsx" />
              <Box className={styles['card-location']} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
                <Icon name="location" type="mediumEmphasis" size={16} data-sentry-element="Icon" data-sentry-source-file="SimilarProductsCard.tsx" />
                <Typography variant="bodyM" color="neutral_600" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">
                  {data?.location?.city}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={styles['footer']} component={'footer'} data-sentry-element="Box" data-sentry-source-file="SimilarProductsCard.tsx">
          <Typography variant="bodyM" color="neutral_600" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">
            هر شب از
          </Typography>
          <Typography variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">
            {moneyFormat(data.pricing?.price_after_discount?.amount)}
          </Typography>
          <Typography variant="bodyM" color="neutral_600" data-sentry-element="Typography" data-sentry-source-file="SimilarProductsCard.tsx">
            تومان
          </Typography>
        </Box>
      </Link>
    </Box>;
};
export default SimilarProductsCard;